export type SystemShortcutAction = 'openFilters';

export type SystemShortcutScope = 'dashboard';

export interface SystemShortcutDefinition {
  id: string;
  combo: string;
  action: SystemShortcutAction;
  scope: SystemShortcutScope;
  allowInEditable: boolean;
  requiresRegisteredAction: boolean;
}

export const SYSTEM_SHORTCUTS: SystemShortcutDefinition[] = [
  {
    id: 'open-filters',
    combo: 'Ctrl+.',
    action: 'openFilters',
    scope: 'dashboard',
    allowInEditable: false,
    requiresRegisteredAction: true
  },
  {
    id: 'open-filters-mac',
    combo: 'Cmd+.',
    action: 'openFilters',
    scope: 'dashboard',
    allowInEditable: false,
    requiresRegisteredAction: true
  }
];
